<template>
  <v-container>
    <v-row dense>
      <v-col v-for="(item, i) in classrooms" :key="i" cols="12">
        <v-card color="#46bd87" dark @click="itemSelection(item)">
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title class="headline" v-text="item.name"></v-card-title>
              <v-card-subtitle
                v-text="'Estudiantes: ' + item.students"
              ></v-card-subtitle>
            </div>

            <v-avatar class="ma-1" size="125" tile>
              <v-img :src="item.src"></v-img>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
      <v-fab-transition>
        <v-btn
          @click="dialog = true"
          color="#46bd87"
          fab
          large
          fixed
          dark
          right
          bottom
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-row>

    <v-row justify="center">
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="submit">
          <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Nuevo aula</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                    dark
                    text
                    type="submit"
                    @click="addNewItem"
                    :disabled="invalid"
                  >
                    Guardar
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-list three-line subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Nombre</v-list-item-title>
                    <ValidationProvider
                      name="nombre"
                      rules="required|max:12"
                      v-slot="{ errors }"
                      vid="nombre"
                    >
                      <v-text-field
                        required
                        id="nombre"
                        name="nombre"
                        type="nombre"
                        label="Nombre del aula"
                        :error="errors.length > 0"
                        :error-messages="errors[0]"
                        autocomplete="off"
                        v-model="newItemName"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Numero de alumnos</v-list-item-title>
                    <ValidationProvider
                      name="alumnos"
                      rules="required|numeric|min_value:1|max_value:60"
                      v-slot="{ errors }"
                      vid="alumnos"
                    >
                      <v-text-field
                        id="alumnos"
                        name="alumnos"
                        type="alumnos"
                        label="Numero de alumnos"
                        v-model="newItemStudentCount"
                        :error="errors.length > 0"
                        :error-messages="errors[0]"
                        autocomplete="off"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Nivel Educativo</v-list-item-title>
                    <v-select
                      v-model="select"
                      :hint="`${select.state}`"
                      :items="educationLevels"
                      item-text="state"
                      item-value="abbr"
                      label="Seleccione"
                      persistent-hint
                      return-object
                      single-line
                    ></v-select>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Curso</v-list-item-title>
                    <v-select
                      v-model="selectCurso"
                      :hint="`${selectCurso}`"
                      :items="cursos"
                      label="Seleccione"
                      persistent-hint
                      return-object
                      single-line
                    ></v-select>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
            </v-card>
          </v-dialog>
        </form>
      </ValidationObserver>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import router from '@/router'

export default {
  data() {
    return {
      dialog: false,
      newItemName: null,
      newItemStudentCount: null,
      newSchoolLevelCount: null,
      educationLevels :  [
          { state: 'Educación Infantil', abbr: 'EI' },
          { state: 'Eduación Primaria', abbr: 'EP' },
          { state: 'Eduación Secundaria', abbr: 'ESO' },
          { state: 'Bachillerato', abbr: 'BACH' },
          { state: 'Formación Profesional', abbr: 'FP' },
          { state: 'Otro', abbr: 'O' },
        ],
      cursos :  [1,2,3,4,5,6,7,8,9,10],
      select: { state: 'Eduación Primaria', abbr: 'EP' },
      selectCurso: 1,
    }
  },
  computed: {
    ...mapGetters('authentication', ['isUserLoggedIn']),
    ...mapState('currentUser', ['currentUser']),
    ...mapState('classrooms', ['classrooms'])
  },
  methods: {
    addItem(item) {
      this.$store.dispatch('classrooms/set', item)
    },
    itemSelection(item) {
      // TODO go to detail view
      console.log(item.id)
      router.replace({ path: `/classroom/${item.id}` })
    },
    addNewItem() {
      const item = {
        name: this.newItemName,
        students: this.newItemStudentCount,
        schoolLevel: this.select,
        course: this.selectCurso
      }
      console.log(item)
      this.$store.dispatch('classrooms/set', item)
      this.dialog = false
      this.newItemName = null
      this.newItemStudentCount = null
      this.newSchoolLevelCount = null
    }
  }
}
</script>
